<template>
	<m-main-layout>
		<el-row :gutter="20" style="margin-bottom: 30px;" v-if="newTotal">
			<el-col :span="8" class="margin-bottom">
				<div class="light padding-20 border-radius-10 hide" style="background-color: #409EFF;">
					<div>今日新增用户</div>
					<div class="f30 margin-top">{{newTotal.daily_user}}</div>
				</div>
			</el-col>
			<el-col :span="8" class="margin-bottom">
				<div class="light padding-20 border-radius-10 hide" style="background-color: #409EFF;">
					<div>今日新增入驻企业</div>
					<div class="f30 margin-top">{{newTotal.daily_company}}</div>
				</div>
			</el-col>
			<el-col :span="8" class="margin-bottom">
				<div class="light padding-20 border-radius-10 hide" style="background-color: #409EFF;">
					<div>今日新增会员</div>
					<div class="f30 margin-top">{{newTotal.daily_vip}}</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="light padding-20 border-radius-10 hide" style="background-color: #67C23A;">
					<div>今日标讯总量</div>
					<div class="f30 margin-top">{{newTotal.daily_bids}}</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="light padding-20 border-radius-10 hide" style="background-color: #67C23A;">
					<div>今日企业发标数量</div>
					<div class="f30 margin-top">{{newTotal.daily_company_bids}}</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="light padding-20 border-radius-10 hide" style="background-color: #67C23A;">
					<div>今日招标网发标数量</div>
					<div class="f30 margin-top">{{newTotal.daily_zbw_bids}}</div>
				</div>
			</el-col>
		</el-row>
<!--		<el-row :gutter="20">-->
<!--			<el-col :span="6">-->
<!--				<div class="bg-brand-0 light padding-20">-->
<!--					<div class="text-right f30 f-b">{{ userCount }}</div>-->
<!--					<div class="text-right f16">今日新增用户</div>-->
<!--				</div>-->
<!--			</el-col>-->
<!--			<el-col :span="6">-->
<!--				<div class="bg-success-0 light padding-20">-->
<!--					<div class="text-right f30 f-b">{{ orderCount }}</div>-->
<!--					<div class="text-right f16">今日新增订单</div>-->
<!--				</div>-->
<!--			</el-col>-->
<!--			<el-col :span="6">-->
<!--				<div class="bg-warning-0 light padding-20">-->
<!--					<div class="text-right f30 f-b">{{ bidsCount }}</div>-->
<!--					<div class="text-right f16">今日新增标讯</div>-->
<!--				</div>-->
<!--			</el-col>-->
<!--			<el-col :span="6">-->
<!--				<div class="bg-danger-0 light padding-20">-->
<!--					<div class="text-right f30 f-b">{{ newsCount }}</div>-->
<!--					<div class="text-right f16">今日新增新闻</div>-->
<!--				</div>-->
<!--			</el-col>-->
<!--		</el-row>-->
		<el-row :gutter="20" class="margin-top">
			<el-col :span="8" class="margin-bottom">
				<el-card class="box-card hide" shadow="hover" style="height: 536px;">
					<div slot="header" class="cl">
						<span style="line-height: 40px;">热门标讯排行</span>
						<range-time class="y" v-model="hot_bids_time" style="width: 300px;" @change="hotBidsTimeChange"></range-time>
					</div>
					<div>
						<el-table border size="mini" :data="hot_bids_list" style="width: 100%" height="397px">
							<el-table-column type="index" label="排序"></el-table-column>
							<el-table-column show-overflow-tooltip prop="title" label="标题">
								<template slot-scope="scope">
									<a :href="$config.webUrl + '/bids/detail/'+scope.row.id" target="_blank">{{scope.row.title}}</a>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="company" label="公司名称" width="180px">
								<template slot-scope="scope">
									<a :href="$config.webUrl + '/company/detail/'+scope.row.uid" target="_blank">{{scope.row.company}}</a>
								</template>
							</el-table-column>
							<el-table-column prop="click_count" label="浏览量" width="80px"></el-table-column>
						</el-table>
						<div class="text-right">
							<el-button type="text" @click="$router.push({path:'/hot/bids'})">更多</el-button>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="margin-bottom">
				<el-card class="box-card hide" shadow="hover" style="height: 536px;">
					<div slot="header" class="cl">
						<span style="line-height: 40px;">活跃企业排行</span>
						<range-time class="y" v-model="hot_company_time" style="width: 300px;" @change="hotCompanyTimeChange"></range-time>
					</div>
					<div>
						<el-table border size="mini" :data="hot_company_list" style="width: 100%" height="397px">
							<el-table-column type="index" label="排序"></el-table-column>
							<el-table-column show-overflow-tooltip prop="company" label="公司名称">
								<template slot-scope="scope">
									<a :href="$config.webUrl + '/company/detail/'+scope.row.uid" target="_blank">{{scope.row.company}}</a>
								</template>
							</el-table-column>
							<el-table-column prop="counts" label="发标数" width="80px"></el-table-column>
						</el-table>
						<div class="text-right">
							<el-button type="text" @click="$router.push({path:'/hot/company',query:{create_time:hot_company_time}})">更多</el-button>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="margin-bottom">
				<el-card class="box-card hide" shadow="hover" style="height: 536px;">
					<div slot="header" class="cl">
						<span style="line-height: 40px;">标讯报名排行</span>
<!--						<range-time class="y" v-model="hot_bids_time" style="width: 300px;" @change="hotBidsTimeChange"></range-time>-->
					</div>
					<div>
						<el-table border size="mini" :data="bids_toubiao_list" style="width: 100%" height="397px">
							<el-table-column type="index" label="排序"></el-table-column>
							<el-table-column show-overflow-tooltip prop="title" label="标题">
								<template slot-scope="scope">
									<a :href="$config.webUrl + '/bids/detail/'+scope.row.tid" target="_blank">{{scope.row.title}}</a>
								</template>
							</el-table-column>
<!--							<el-table-column show-overflow-tooltip prop="company" label="公司名称" width="180px">-->
<!--								<template slot-scope="scope">-->
<!--									<a :href="$config.webUrl + '/company/detail/'+scope.row.target_uid" target="_blank">{{scope.row.company}}</a>-->
<!--								</template>-->
<!--							</el-table-column>-->
							<el-table-column prop="count" label="报名量" width="80px">
<!--								/admin/bids/baoming?id=718854564903649280-->
								<template slot-scope="scope">
									<b class="hand" @click="$router.push({path:'/bids/baoming',query:{id:scope.row.tid}})">{{scope.row.count}}</b>
								</template>
							</el-table-column>
						</el-table>
						<div class="text-right">
							<el-button type="text" @click="$router.push({path:'/hot/toubiao'})">更多</el-button>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="12" class="margin-bottom">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="cl">
						<span style="line-height: 40px;">用户注册</span>
						<el-button icon="el-icon-refresh" size="mini" class="margin-left" @click="getTotal('user','注册人数',user_total_time,'家')"></el-button>
						<range-time class="y" v-model="user_total_time" style="width: 300px;" @change="userTimeChange"></range-time>
					</div>
					<div>
						<lee-bar-echarts
							ref="user"
							:grid-bottom="30"
							:height="'250px'"
							:show-legend="false"
							:show-left="true"
							:show-right="false"></lee-bar-echarts>
					</div>
				</el-card>
			</el-col>
<!--			<el-col :span="12" class="margin-bottom">-->
<!--				<el-card class="box-card" shadow="hover">-->
<!--					<div slot="header" class="cl">-->
<!--						<span style="line-height: 40px;">日活频次</span>-->
<!--						<range-time class="y" v-model="login_total_time" style="width: 300px;" @change="loginTimeChange"></range-time>-->
<!--					</div>-->
<!--					<div>-->
<!--						<lee-bar-echarts-->
<!--							ref="login"-->
<!--							:grid-bottom="30"-->
<!--							:height="'250px'"-->
<!--							:show-legend="false"-->
<!--							:show-left="true"-->
<!--							:show-right="false"></lee-bar-echarts>-->
<!--					</div>-->
<!--				</el-card>-->
<!--			</el-col>-->
<!--			<el-col :span="12" class="margin-bottom">-->
<!--				<el-card class="box-card" shadow="hover">-->
<!--					<div slot="header" class="cl">-->
<!--						<span style="line-height: 40px;">游客访问人次</span>-->
<!--						<range-time class="y" v-model="free_visit_total_time" style="width: 300px;" @change="freeVisitTimeChange"></range-time>-->
<!--					</div>-->
<!--					<div>-->
<!--						<lee-bar-echarts-->
<!--							ref="free_visit"-->
<!--							:grid-bottom="30"-->
<!--							:height="'250px'"-->
<!--							:show-legend="false"-->
<!--							:show-left="true"-->
<!--							:show-right="false"></lee-bar-echarts>-->
<!--					</div>-->
<!--				</el-card>-->
<!--			</el-col>-->
<!--			<el-col :span="12" class="margin-bottom">-->
<!--				<el-card class="box-card" shadow="hover">-->
<!--					<div slot="header" class="cl">-->
<!--						<span style="line-height: 40px;">访问统计</span>-->
<!--						<range-time class="y" v-model="page_visit_total_time" style="width: 300px;" @change="pageVisitTimeChange"></range-time>-->
<!--					</div>-->
<!--					<div>-->
<!--						<lee-bar-echarts-->
<!--							ref="page_visit"-->
<!--							:grid-bottom="30"-->
<!--							:height="'250px'"-->
<!--							:show-legend="false"-->
<!--							:show-left="true"-->
<!--							:show-right="false"></lee-bar-echarts>-->
<!--					</div>-->
<!--				</el-card>-->
<!--			</el-col>-->
			<el-col :span="12" class="margin-bottom">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="cl">
						<span style="line-height: 40px;">访问统计</span>
						<el-button icon="el-icon-refresh" size="mini" class="margin-left" @click="getTotal('total_visit','次',total_visit_time,'次')"></el-button>
						<range-time class="y" v-model="total_visit_time" style="width: 300px;" @change="visitTimeChange"></range-time>
					</div>
					<div>
						<lee-bar-echarts
							ref="total_visit"
							:grid-bottom="30"
							:height="'250px'"
							:show-legend="false"
							:show-left="true"
							:show-right="false"></lee-bar-echarts>
					</div>
				</el-card>
			</el-col>
			<el-col :span="12" class="margin-bottom">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="cl">
						<span style="line-height: 40px;">企业发标数量</span>
						<el-button icon="el-icon-refresh" size="mini" class="margin-left" @click="getTotal('user_bids','企业发标数量',bids_total_time,'条')"></el-button>
						<range-time class="y" v-model="bids_total_time" style="width: 300px;" @change="bidsTimeChange"></range-time>
					</div>
					<div>
						<lee-bar-echarts
							ref="user_bids"
							:grid-bottom="30"
							:height="'250px'"
							:show-legend="false"
							:show-left="true"
							:show-right="false"></lee-bar-echarts>
					</div>
				</el-card>
			</el-col>
			<el-col :span="12" class="margin-bottom">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="cl">
						<span style="line-height: 40px;">平台发标数量</span>
						<el-button icon="el-icon-refresh" size="mini" class="margin-left" @click="getTotal('system_bids','平台发标数量',system_bids_total_time,'条')"></el-button>
						<range-time class="y" v-model="system_bids_total_time" style="width: 300px;" @change="SystembidsTimeChange"></range-time>
					</div>
					<div>
						<lee-bar-echarts
							ref="system_bids"
							:grid-bottom="30"
							:height="'250px'"
							:show-legend="false"
							:show-left="true"
							:show-right="false"></lee-bar-echarts>
					</div>
				</el-card>
			</el-col>
			<el-col :span="12" class="margin-bottom">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="cl">
						<span style="line-height: 40px;">热词搜索排行</span>
					</div>
					<div>
						<lee-bar-echarts
							ref="hot_words"
							:grid-bottom="30"
							:height="'250px'"
							:show-legend="false"
							:show-left="true"
							:show-right="false"></lee-bar-echarts>
					</div>
				</el-card>
			</el-col>
<!--			<el-col :span="12" class="margin-bottom">-->
<!--				<el-card class="box-card" shadow="hover">-->
<!--					<div slot="header" class="cl">-->
<!--						<span style="line-height: 40px;">用户统计</span>-->
<!--						<range-time class="y" v-model="user_total_time" style="width: 300px;" @change="userTimeChange"></range-time>-->
<!--					</div>-->
<!--					<div>-->
<!--						<lee-bar-echarts-->
<!--							ref="bar1"-->
<!--							:grid-bottom="30"-->
<!--							:height="'250px'"-->
<!--							:show-legend="false"-->
<!--							:show-left="true"-->
<!--							:show-right="false"></lee-bar-echarts>-->
<!--					</div>-->
<!--				</el-card>-->
<!--			</el-col>-->
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<span>新增会员列表</span>
					</div>
					<div v-for="(item,index) in userList" class="cl" style="line-height: 30px;">
						<div class="z">{{ item.mobile }}</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<span>热门标讯</span>
					</div>
					<div v-for="(item,index) in hotBidsList" class="cl rel" style="line-height: 30px;">
						<div class="text-line-1" style="margin-right:80px;">
							<a :href="'/bids/detail/'+item.id" target="_blank">{{ item.title }}</a>
						</div>
						<span class="abs" style="right:0;top:0;">{{ item.click_count }}<i class="dark-3 f12 margin-left el-icon-view"></i></span>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<span>热门新闻</span>
					</div>
					<div v-for="(item,index) in hotNewsList" class="cl rel" style="line-height: 30px;">
						<div class="text-line-1" style="margin-right:80px;">
							<a :href="'/news/detail/'+item.id" target="_blank">{{ item.title }}</a>
						</div>
						<span class="abs" style="right:0;top:0;">{{ item.click_count }}<i class="dark-3 f12 margin-left el-icon-view"></i></span>
					</div>
				</el-card>
			</el-col>
		</el-row>
<!--		<el-row :gutter="20" class="margin-top">-->
<!--			-->
<!--		</el-row>-->
	</m-main-layout>
</template>

<script>
export default {
	name: "DashBoard",
	data() {
		return {
			today: '',
			userCount: 0,
			orderCount: 0,
			bidsCount: 0,
			newsCount: 0,
			userList: [],
			hotBidsList: [],
			hotNewsList: [],

			user_total_time:'',
			bids_total_time:'',
			system_bids_total_time:'',
			// login_total_time:'',
			// free_visit_total_time:'',
			// page_visit_total_time:'',
			total_visit_time:'',

			start_time: '',
			end_time: '',

			hot_bids_time:'',
			hot_company_time:'',

			hot_bids_list:[],
			hot_company_list:[],
			bids_toubiao_list:[],

			newTotal:null
		}
	},
	created() {
		let _date = new Date();

		let _year = _date.getFullYear();
		let _month = _date.getMonth() + 1;
		let _day = _date.getDate();

		let _today = _year + '-' + _month + '-' + _day;

		this.today = this.$moment(_today).unix();

		this.start_time = this.$moment().startOf('week').format('YYYY-MM-DD'); //本周一
		this.end_time = this.$moment().endOf('week').format('YYYY-MM-DD'); //本周日
		// this.start_time = this.$moment().weekday(1).format('YYYY-MM-DD'); //本周一
		// this.end_time = this.$moment().weekday(7).format('YYYY-MM-DD'); //本周日

		this.bids_total_time = this.start_time + ',' + this.end_time;
		this.system_bids_total_time = this.start_time + ',' + this.end_time;
		// this.login_total_time = this.start_time + ',' + this.end_time;

		this.user_total_time = this.start_time + ',' + this.end_time;
		this.hot_bids_time = this.start_time + ',' + this.end_time;
		this.hot_company_time = this.start_time + ',' + this.end_time;
		// this.free_visit_total_time = this.start_time + ',' + this.end_time;
		// this.page_visit_total_time = this.start_time + ',' + this.end_time;
		this.total_visit_time = this.start_time + ',' + this.end_time;
	},
	mounted() {
		this.getUserCount();
		this.getOrderCount();
		this.getBidsCount();
		this.getNewsCount();
		this.getUserList();
		this.getBidsList();
		this.getNewsList();

		// this.getTotal('user');
		this.getTotal('user','注册人数',this.user_total_time,'家');
		this.getTotal('user_bids','企业发标数量',this.bids_total_time,'条');
		this.getTotal('system_bids','平台发标数量',this.system_bids_total_time,'条');
		// this.getTotal('login','登录');
		// this.getTotal('free_visit','人次');
		// this.getTotal('page_visit','次');
		this.getTotal('total_visit','人次',this.total_visit_time,'次');
		this.getHotWordsTotal();

		this.getNewTotal();
		this.getHotBidsTotal();
		this.getHotCompanyTotal();
		this.getBidsToubiaoTotal();
	},
	methods: {
		hotBidsTimeChange(e){
			this.getHotBidsTotal(e);
		},
		hotCompanyTimeChange(e){
			this.getHotCompanyTotal(e);
		},
		getNewTotal(){
			let _this = this;
			_this.$http.httpPost({
				url: '/SystemTotal/getTotal',
				datas: null,
				success: (res) => {
					_this.newTotal = res;
				}
			});
		},
		getHotBidsTotal(time){
			let _this = this;

			_this.$http.httpPost({
				url: '/Bids/listPage',
				datas: {orderBy:'click_count',sortBy:'desc',page:1,pageSize:10,create_time:time ? time : this.hot_bids_time},
				success: (res) => {
					_this.hot_bids_list = res.list;
				}
			});
		},
		getHotCompanyTotal(time){
			let _this = this;

			_this.$http.httpPost({
				url: '/SystemTotal/getCompanyBidsTotal',
				datas: {page:1,pageSize:10,create_time:time ? time : this.hot_bids_time},
				success: (res) => {
					_this.hot_company_list = res.list;
				}
			});
		},
		getBidsToubiaoTotal(){
			let _this = this;

			_this.$http.httpPost({
				url: '/UserToubiaoLog/getTotal',
				datas:null,
				success: (res) => {
					_this.bids_toubiao_list = res.list;
				}
			});
		},
		getUserCount() {
			let _this = this;
			_this.$http.httpPost({
				url: '/User/count',
				datas: {create_time: [this.today, '>=']},
				success: (res) => {
					_this.userCount = res.count;
				}
			});
		},
		getOrderCount() {
			let _this = this;
			_this.$http.httpPost({
				url: '/Order/count',
				datas: {create_time: [this.today, '>='], state: 2},
				success: (res) => {
					_this.orderCount = res.count;
				}
			});
		},
		getBidsCount() {
			let _this = this;
			_this.$http.httpPost({
				url: '/Bids/count',
				datas: {create_time: [this.today, '>=']},
				success: (res) => {
					_this.bidsCount = res.count;
				}
			});
		},
		getNewsCount() {
			let _this = this;
			_this.$http.httpPost({
				url: '/News/count',
				datas: {create_time: [this.today, '>=']},
				success: (res) => {
					_this.newsCount = res.count;
				}
			});
		},
		getUserList() {
			let _this = this;
			_this.$http.httpPost({
				url: '/User/listAll',
				datas: {orderBy: 'create_time', sortBy: 'desc', limit: 8},
				success: (res) => {
					_this.userList = res;
				}
			});
		},
		getBidsList() {
			let _this = this;
			_this.$http.httpPost({
				url: '/Bids/listPage',
				datas: {orderBy: 'click_count', sortBy: 'desc',page:1,pageSize: 8},
				success: (res) => {
					_this.hotBidsList = res.list;
				}
			});
		},
		getNewsList() {
			let _this = this;
			_this.$http.httpPost({
				url: '/News/listAll',
				datas: {orderBy: 'click_count', sortBy: 'desc', limit: 8},
				success: (res) => {
					_this.hotNewsList = res;
				}
			});
		},
		// userTimeChange(e) {
		// 	console.log(e);
		// 	this.getTotal('user', e);
		// },
		// loginTimeChange(e){
		// 	this.getTotal('login','登录人数',e);
		// },
		// freeVisitTimeChange(e){
		// 	this.getTotal('free_visit','人次',e);
		// },
		// pageVisitTimeChange(e){
		// 	this.getTotal('page_visit','次',e);
		// },
		visitTimeChange(e){
			this.getTotal('total_visit','次',e,'次');
		},
		userTimeChange(e){
			this.getTotal('user','注册人数',e,'家');
		},
		bidsTimeChange(e){
			this.getTotal('user_bids','企业发标数量',e,'条');
		},
		SystembidsTimeChange(e){
			this.getTotal('system_bids','平台发标数量',e,'条');
		},
		getTotal(type,title,time = null,dw = ''){
			let _this = this;

			if(type === 'total_visit'){
				_this.$http.httpPost({
					url: '/SystemTotal/listAll',
					datas: {type: ['visit','page_visit'], total_time: time, orderBy: 'total_time', sortBy: 'asc'},
					success: (res) => {
						let _bar1 = {bar: [], xaxis: []};
						let _bar2 = {bar: [], xaxis: []};

						for (let i = 0; i < res.visit.length; i++) {
							_bar1.bar.push(res.visit[i].count);

							let _time = _this.$moment.unix(res.visit[i].total_time).format('YYYY-M-D')
							_bar1.xaxis.push(_time);
						}

						for (let i = 0; i < res.page_visit.length; i++) {
							_bar2.bar.push(res.page_visit[i].count);

							let _time = _this.$moment.unix(res.page_visit[i].total_time).format('YYYY-M-D')
							_bar2.xaxis.push(_time);
						}

						if (_this.$refs['total_visit']) {
							_this.$refs['total_visit'].initData(
								[
									{name: '访问人次', type: 'bar', color: 'blue', data: _bar1.bar, dw: dw},
									{name: '访问次数', type: 'bar', color: 'red', data: _bar2.bar, dw: dw},
								],
								_bar1.xaxis
							);
						}
					}
				})
			}else {
				_this.$http.httpPost({
					url: '/SystemTotal/listAll',
					datas: {type: type, total_time: time, orderBy: 'total_time', sortBy: 'asc'},
					success: (res) => {
						let _bar1 = {bar: [], xaxis: []};

						for (let i = 0; i < res.length; i++) {
							_bar1.bar.push(res[i].count);

							let _time = _this.$moment.unix(res[i].total_time).format('YYYY-M-D')
							_bar1.xaxis.push(_time);
						}

						// let _dw = '';
						//
						// if(type === 'login'){
						// 	_dw = '次';
						// }else if(type === 'user_bids'){
						// 	_dw = '条';
						// }else if(type === 'system_bids'){
						// 	_dw = '条';
						// }else if(type === 'user'){
						// 	_dw = '家';
						// }

						if (_this.$refs[type]) {
							_this.$refs[type].initData(
								[
									{name: title, type: 'bar', color: 'blue', data: _bar1.bar, dw: dw},
								],
								_bar1.xaxis
							);
						}
					}
				});
			}
		},
		getHotWordsTotal(){
			let _this = this;
			_this.$http.httpPost({
				url: '/HotWords/listAll',
				datas: {orderBy:'count',sortBy:'desc',limit:10},
				success: (res) => {
					let _bar1 = {bar:[],xaxis:[]};

					for (let i=0;i < res.length;i++) {
						_bar1.bar.push(res[i].count);

						_bar1.xaxis.push(res[i].title);
					}

					if(_this.$refs['hot_words']) {
						_this.$refs['hot_words'].initData(
							[
								{name: '热词', type: 'bar', color: 'blue', data: _bar1.bar,dw:'次'},
							],
							_bar1.xaxis
						);
					}
				}
			});
		}
		// getTotal(type, time = null) {
		// 	let _this = this;
		// 	_this.$http.httpPost({
		// 		url: '/SystemTotal/listAll',
		// 		datas: {type: type, total_time: time ? time : this.user_total_time, orderBy: 'total_time', sortBy: 'asc'},
		// 		success: (res) => {
		// 			console.log(res);
		//
		// 			let _bar1 = {bar: [], xaxis: []};
		//
		// 			for (let i = 0; i < res.length; i++) {
		// 				_bar1.bar.push(res[i].count);
		//
		// 				let _time = _this.$moment.unix(res[i].total_time).format('YYYY-M-D')
		// 				_bar1.xaxis.push(_time);
		// 			}
		//
		// 			if (_this.$refs.bar1) {
		// 				_this.$refs.bar1.initData(
		// 					[
		// 						{name: '注册人数', type: 'bar', color: 'blue', data: _bar1.bar},
		// 					],
		// 					_bar1.xaxis
		// 				);
		// 			}
		// 		}
		// 	});
		// }
	}
}
</script>
